module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-break-fill-36cb46f2.svg";